import { render, staticRenderFns } from "./myMessage.vue?vue&type=template&id=3793f3b2&scoped=true"
import script from "./myMessage.vue?vue&type=script&lang=js"
export * from "./myMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3793f3b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3793f3b2')) {
      api.createRecord('3793f3b2', component.options)
    } else {
      api.reload('3793f3b2', component.options)
    }
    module.hot.accept("./myMessage.vue?vue&type=template&id=3793f3b2&scoped=true", function () {
      api.rerender('3793f3b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/myMessage.vue"
export default component.exports